import { watch } from 'vue';
import { storeToRefs } from 'pinia';

import googleAnalytics from '@js/dom/analytics';

import useAuthStore from '@/stores/auth';

// Iframed, the first screen settles before the host's token arrives: it counts once the user does.
export default function pageView(router) {
  let awaiting = null;

  return function counted(to) {
    const { user } = storeToRefs(useAuthStore());

    if (user.value.id) {
      googleAnalytics(to, user.value.id);

      return;
    }

    if (awaiting) {
      return;
    }

    awaiting = watch(() => user.value.id, (id) => {
      if (!id) {
        return;
      }

      awaiting();
      awaiting = null;

      googleAnalytics(router.currentRoute.value, id);
    });
  };
}
